export const dateTimeFormatUTCDate = (date: string) => {
    const d = new Date(date);

    const month = d.toLocaleString("en-US", {
        month: "short",
        timeZone: "UTC",
    });

    const day = String(d.getUTCDate()).padStart(2, "0");
    const year = d.getUTCFullYear();

    const hours = d.getUTCHours();
    const minutes = String(d.getUTCMinutes()).padStart(2, "0");

    const hour12 = hours % 12 || 12;
    const period = hours >= 12 ? "PM" : "AM";
    
    return `${month}. ${day}, ${year} ${String(hour12).padStart(2, "0")}:${minutes}${period}`;
}